export class Flow {
    id?: string;
    name: string;
    description: string;

    constructor(flow) {
        if (flow.id) { this.id = flow.id; }
        this.name = flow.name;
        this.description = flow.description;
    }
}
